import React from 'react';
import { connect } from 'react-redux';
import { AppState } from '@Redux/store';
import { Dispatch } from '@Redux/type';
import GoogleMapComponent from '@Components/federation/google-map.component';
import { ClubsPresenter } from '@Selectors/federation/clubs.presenter';
import { PlayersPresenter } from '@Selectors/federation/players.presenter';
import { APIProvider } from '@vis.gl/react-google-maps';
import { TYPES } from '@Types';
import { container } from '@Container';
import { ClubsAction } from '@Redux/actions/federation/clubs.action';
import { ClubCategoriesPresenter } from '@Selectors/federation/club-categories.presenter';
import { UserPreferenceAction } from '@Redux/actions';
import { PlayersAction } from '@Redux/actions/federation/players.action';

const FederationClubPageIndex: React.FC<Props> = ({
                                                    clubs,
                                                    categories,
                                                    players,
                                                    load
                                                  }) => {

  React.useEffect(() => {
    load();
  }, []);

  return (
    <APIProvider apiKey={process.env.MAP_API_KEY ?? ''}>
      <GoogleMapComponent clubs={clubs} players={players} categories={categories} />
    </APIProvider>
  );
};

const mapStateToProps = (state: AppState) => ({
  clubs: ClubsPresenter(state),
  players: PlayersPresenter(state),
  categories: ClubCategoriesPresenter(state)
});

const mapDispatchToProps = (dispatch: Dispatch) => {

  const clubsAction = container.get<ClubsAction>(TYPES.Actions.Federation.ClubsAction);
  const userAction = container.get<UserPreferenceAction>(TYPES.Actions.User.UserPreferenceAction);
  const playerAction = container.get<PlayersAction>(TYPES.Actions.Federation.PlayersAction);

  return {
    load: () => {
      dispatch(clubsAction.fetchData())
      dispatch(userAction.fetchData())
      dispatch(playerAction.fetchData())
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FederationClubPageIndex);

type Props = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
